import "react-nice-dates/build/style.css";
import Loading from "../../../components/basics/Loading";

import HeaderModule from "../../../components/header/HeaderModule";

import { Divider, Grid } from "@material-ui/core";
import Filter from "./children/Filter";
import { ReportActions } from "./children/Report/ReportActions";
import ReportDataGrid from "./children/Report/ReportDataGrid";
import { ReportHeader } from "./children/Report/ReportHeader";
import {
  ContasReceberProvider,
  useContasReceberService,
} from "./context/ContasReceberContext";

const View = () => {
  const { mainLoading, mainRefetchLoading } = useContasReceberService();

  return (
    <>
      <HeaderModule title="CONTAS A RECEBER" />
      <Loading open={mainLoading || mainRefetchLoading} />
      <Grid
        container
        direction="column"
        style={{ marginTop: 80, marginBottom: 40, padding: "0px 16px" }}
        spacing={2}
      >
        <Filter />

        <ReportHeader />
        <ReportActions />
        <Divider />

        <ReportDataGrid />
      </Grid>
    </>
  );
};

const ContasReceber = (props) => (
  <ContasReceberProvider>
    <View {...props} />
  </ContasReceberProvider>
);

export default ContasReceber;
